/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import ErrorName from '../error/error-name';

const abortMessage = 'Waiting for an event was aborted.';

/**
 * Převede čekání na událost na promise s možností předčasného ukončení.
 * @param {EventEmitter} emitter Emitter, který vyvolá událost.
 * @param {string} type Typ vyvolané události
 * @param {Object} [opts]
 * @param {AbortSignal} [opts.abortSignal] Signál pro předčasné přerušení.
 * @throws {AbortError} Čekání bylo předčasně ukončeno.
 * @returns {Promise.<*>} Parametry shodné s těmi, které má callback události.
 */
function promisifyEventEmitter(
  emitter,
  type,
  { abortSignal = new AbortSignal() }
) {
  return new Promise((resolve, reject) => {
    if (abortSignal.aborted) {
      const error = new Error(abortMessage);
      error.name = ErrorName.AbortError;
      throw error;
    }
    const listener = (...args) => {
      emitter.off(type, listener);
      abortSignal.removeEventListener('abort', abortListener);
      return resolve(...args);
    };
    const abortListener = () => {
      emitter.off(type, listener);
      abortSignal.removeEventListener('abort', abortListener);
      const error = new Error(abortMessage);
      error.name = ErrorName.AbortError;
      return reject(error);
    };
    emitter.on(type, listener);
    abortSignal.addEventListener('abort', abortListener);
  });
}

export default promisifyEventEmitter;
